// External website for the Nova SecureNet subsidiary. Nova operates its
// own separate site; all Nova links on the AMS site point here.
export const NOVA_URL = "https://novasecurenet.com";

export const COMPANIES = [
  {
    id: "atm",
    name: "AMS ATM Services",
    tagline: "Cash access, wherever it's needed.",
    description:
      "Reliable ATM placement and cash access solutions for retail locations, venues, and events across Alberta.",
    services: ["ATM placement", "Event ATMs", "Cash access solutions"],
    image:
      "https://images.unsplash.com/photo-1601597110547-78516f198ce4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhdG0lMjBtYWNoaW5lJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzgzNTUyNTI1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "moving",
    name: "Professional Moving",
    tagline: "Careful hands. Seamless moves.",
    description:
      "Full-service residential and commercial moving with the care and precision every relocation deserves.",
    services: ["Residential moving", "Commercial moving", "Specialty moves"],
    image:
      "https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBtb3ZlcnMlMjBtb3ZpbmclMjBib3hlc3xlbnwwfHx8fDE3ODM1NTI1MjV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "nova",
    name: "Nova SecureNet",
    tagline: "The website & digital services division of AMS.",
    description:
      "Nova SecureNet is the website, digital services and technology division of AMS Venture Holdings Inc.",
    services: [
      "Professional website design & development",
      "Website hosting & maintenance",
      "Digital support & practical technology solutions",
      "Security-conscious website services",
    ],
    external: true,
    url: NOVA_URL,
    image:
      "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const VALUES = [
  {
    title: "Professionalism",
    body: "Every interaction, from first call to final handshake, is handled with expertise and respect.",
    icon: "BadgeCheck",
  },
  {
    title: "Reliability",
    body: "We show up, follow through, and deliver on what we promise, every single time.",
    icon: "ShieldCheck",
  },
  {
    title: "Transparent Communication",
    body: "Clear pricing, honest timelines, and no surprises. You always know where things stand.",
    icon: "MessageSquare",
  },
  {
    title: "Long-term Relationships",
    body: "We build businesses meant to serve their communities for years, not just transactions.",
    icon: "Handshake",
  },
];

export const CONTACT_INFO = {
  email: "info@amsventures.ca",
  location: "Edmonton, Alberta, Canada",
  hours: "Monday – Friday, 9:00 AM – 5:00 PM MT",
  aboutBanner:
    "https://images.unsplash.com/photo-1764745222636-7fb0e22d4b1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxjYW5hZGlhbiUyMGJ1c2luZXNzJTIwcHJvZmVzc2lvbmFscyUyMG1lZXRpbmd8ZW58MHx8fHwxNzgzNTUyNTI1fDA&ixlib=rb-4.1.0&q=85",
};
